import $ from 'jquery';
import {ENDERECO_API} from '../../config/constant';
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import {showDuplicateLoginAlert} from '../../components/Auth/DuplicateLoginAlert';
//import { decode as base64_decode } from 'base-64';

const ajaxApiV2Event = (type, ll, dd, tk, rejectMessage, pp = 'apiV2') => {
  
  
  return new Promise(function (resolve, reject) {
    try {
      $.ajax({
        url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
        type,
        dataType: 'text',
        headers: {
          'Authorization': 'Bearer ' + tk,
        },
        data: {
          pp: base64_encode(pp),
          ll: base64_encode(ll),
          dd: base64_encode(JSON.stringify(dd)),
          tk,
        },
        success: function (data) {
          
          
          let decoded;
          try {
            decoded = base64_decode(data);
            data = JSON.parse(decoded);
            resolve([200, data]);
          } catch (e) {
            reject([500, {message: 'Erro ao processar resposta do servidor'}]);
          }
        },
        error: function (xhr, status, error) {
          console.error('Erro AJAX:', {xhr});
          if (xhr?.message === 'erro_auth') {
            showDuplicateLoginAlert();
          }
          reject([400, {message: rejectMessage}]);
        },
      });
    } catch (err) {
      reject([500, {message: 'Server Error'}]);
    }
  });
};

const RestApiV2Post = (config) => {
  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  switch (caminho) {
    case 'apiV2':
      return ajaxApiV2Event('POST', 'apiV2List', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost || {}))], token, 'Erro ao carregar catálogo de relatórios');
    case 'apiv2_try':
      return ajaxApiV2Event('POST', 'apiv2_try', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost || {}))], token, 'Erro ao executar requisição v2');

    case 'gerarCredenciaisApiV2': {
      const dataPost = Arr_.dataPost ?? [];
      return ajaxApiV2Event('POST', 'gerarCredenciaisApiV2', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))], token, 'Erro ao gerar credenciais');
    }

      default:
      return new Promise((resolve) => resolve([404, {message: 'Rota não encontrada'}]));
  }
};

const RestApiV2Get = (config) => {

  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];
  const acao = config?.params?.dest || '';
  switch (acao) {
    case 'apiV2List':
      
      
      return ajaxApiV2Event('GET', 'apiV2List', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify({}))], token, 'Erro ao listar dossiês');

    case 'buscarCredenciaisApiV2':
      return ajaxApiV2Event('GET', 'buscarCredenciaisApiV2', [base64_encode(emp), base64_encode(uid)], token, 'Erro ao buscar credenciais');

      default:
      return new Promise((resolve) => resolve([404, {message: 'Rota não encontrada: '}]));
  }
};

export {RestApiV2Post, RestApiV2Get};
